import { Component, ElementRef, forwardRef, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { fadeInOutAnimation, GlobalComponentService } from '@techmore/global';
import { ABSTRACT_TEMPLATE_TOKEN, AbstractTemplate } from '../../../abstract-template';
import { MemberPreferenceModalComponent } from '../../../component/member-preference-modal/member-preference-modal.component';
import { Subscription, timer } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EventReplayer } from 'preboot';
import { BackStageTemplateService } from '../../../../../share/service/back-stage-template.service';
import { ServerConfigService } from '../../../../../share/service/server-config.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from '../../../../generator-env-token';
import { TemplateService } from '../../../service/template.service';
import { MEMBER_LOGIN_WAY } from '../../../../../member/entity/member-login-way';
import { HttpErrorResponse } from '@angular/common/http';
import { OAuthError } from '../../../../../share/entity/OauthError';
import { MemberProxyService } from '../../../../../member/service/member-proxy.service';
import { LoggerService } from '../../../../../share/service/logger.service';
import { CloseOnContainerBlurDirective } from '@techmore/share';
import { Bs5ModalDirective } from '../../../../../share/directive/bs5-modal.directive';
import { FontSizeService } from '../../../../../share/service/font-size-service';

@Component({
  selector: 'app-template-001',
  templateUrl: './index.component.html',
  styleUrls: [
    './index.component.scss',
    './index-search-04.component.scss',
    './custom_control.scss'
  ],
  providers: [
    {provide: ABSTRACT_TEMPLATE_TOKEN,  useExisting: forwardRef(() => IndexComponent), multi: false}
  ],
  animations: [fadeInOutAnimation],
  encapsulation: ViewEncapsulation.None
})
export class IndexComponent extends AbstractTemplate implements OnInit, OnDestroy {
  /** 會員偏好modal */
  @ViewChild(MemberPreferenceModalComponent, { static: false }) mpModal: MemberPreferenceModalComponent;
  /** 到首頁的路徑 */
  toHomePath: string;
  /** 是否有設定會員登入機制 */
  hasLoginSys = false;
  /** 已登入的會員資料 */
  memberInfo: any;
  /** 正在以某種方式登入會員中 */
  loginIng = false;
  private _subcs: Subscription[] = [];
  private _calHasMemberSubc: Subscription;
  private _memberInfSubc: Subscription;
  private _recapchaAriaTimerSubc: Subscription;
  private _routerChangeCloseMenuSubc: Subscription;
  /** 主選單彈出視窗指令實例 */
  @ViewChild('mainMenuModal', {static: false}) mainMenuModal: Bs5ModalDirective;
  /** 主選單自動關閉窗口指令 */
  @ViewChild('mainMenuCcb', {static: false}) set mainMenuCcb(ccb: CloseOnContainerBlurDirective) {
    ccb.closeContainer = (toggler?: HTMLElement, container?: HTMLElement) => {
      if (this.isBrowser) {
        this.mainMenuModal.hide();
      }
    };
    ccb.listenOnOpen = (cb: () => void) => {
      if (this.isBrowser) {
        this.mainMenuModal.showned.subscribe(() => {
          cb();
        });
      }
    };
    ccb.listenOnClose = (cb: () => void) => {
      if (this.isBrowser) {
        this.mainMenuModal.hiddened.subscribe(() => {
          cb();
        });
      }
    };
  }

  constructor(
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    protected templateService: TemplateService,
    protected router: Router,
    protected route: ActivatedRoute,
    @Inject(DOCUMENT) protected document: any,
    protected translate: TranslateService,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected render: Renderer2,
    protected el: ElementRef,
    protected serverConfigService: ServerConfigService,
    protected backStageTemplateService: BackStageTemplateService,
    protected replayer: EventReplayer,
    protected memberService: MemberProxyService,
    protected globalComponentService: GlobalComponentService,
    protected loggerService: LoggerService,
    protected translateService: TranslateService,
    protected fontSizeService: FontSizeService,
  ) {
    super(generatorEnv, templateService, router, route, document, translate, platformId, render, el, serverConfigService, backStageTemplateService, replayer);
    this.toHomePath = `/${translateService.currentLang}`;
    if (!this.isBrowser) {
      this.loggerService.info(`template-001 constructor`);
    }
  }
  
  ngOnInit(): void {
    super.ngOnInit();
    if (!this.isBrowser) {
      this.loggerService.info(`template-001 super ngOnInit`);
    }
    
    if (this.isBrowser) {
      this._routerChangeCloseMenuSubc = this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
          return;
        }
        if (this.mainMenuModal && this.mainMenuModal.isShow) {
          this.mainMenuModal.hide();
        }
      });
      
      this._recapchaAriaTimerSubc = timer(50, 200).subscribe(t => {
        const grecaptchaBadge = this.document.querySelector('.grecaptcha-badge') as HTMLElement;
        if (grecaptchaBadge) {
          if (grecaptchaBadge.nextElementSibling && grecaptchaBadge.nextElementSibling instanceof HTMLIFrameElement) { // 應該是個隱藏iframe
            grecaptchaBadge.nextElementSibling.title = '機器人驗證';
            grecaptchaBadge.nextElementSibling.setAttribute('sandbox', 'allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation');
          }
          const responseTextarea = grecaptchaBadge.querySelector('textarea.g-recaptcha-response') as HTMLTextAreaElement;
          if (responseTextarea) {
            responseTextarea.title = '機器人驗證回應';
          }
  
          if (grecaptchaBadge.nextElementSibling && (grecaptchaBadge.nextElementSibling as HTMLIFrameElement).title
          && responseTextarea && responseTextarea.title) {
            this._recapchaAriaTimerSubc.unsubscribe();
            delete this._recapchaAriaTimerSubc;
          }
        }
      });

      this._calHasMemberSubc = this.memberService.getHasLoginSystem$().subscribe(v => {
        this.hasLoginSys = v;
      });

      this._memberInfSubc = this.memberService.getMemberInfo$().subscribe(info => {
        this.memberInfo = info;
      });

      this.memberService.getOnLoginStart$().subscribe(() => {
        this.loginIng = true;
      });

      this.memberService.getOnLoginEnd$().subscribe(() => {
        this.loginIng = false;
      });
    }

    if (!this.isBrowser) {
      this.loggerService.info(`template-001 ngOnInit end`);
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();

    if (!this.isBrowser) {
      this.loggerService.info(`template-001 super ngOnDestroy`);
    }
    if (this._routerChangeCloseMenuSubc) {
      this._routerChangeCloseMenuSubc.unsubscribe();
    }
    if (this._calHasMemberSubc) {
      this._calHasMemberSubc.unsubscribe();
    }
    if (this._memberInfSubc) {
      this._memberInfSubc.unsubscribe();
    }
    while (this._subcs.length) {
      this._subcs.pop().unsubscribe();
    }
    if (this._recapchaAriaTimerSubc) {
      this._recapchaAriaTimerSubc.unsubscribe();
      delete this._recapchaAriaTimerSubc;
    }
    if (!this.isBrowser) {
      this.loggerService.info(`template-001 ngOnDestroy end`);
    }
  }

  openCultureCenterLogin() {
    if (!this.loginIng && !this.memberInfo) {
      this.memberService.login(MEMBER_LOGIN_WAY.CULTURE_CENTER).subscribe(v => {
      }, error => {
        console.error(error);
        try {
          if (error instanceof HttpErrorResponse) {
            let oauthError: OAuthError;
            oauthError = $.extend(new OAuthError(this.translate), error.error);
            this.globalComponentService.openErrorAlert(oauthError.getMessage());
          } else {
            this.globalComponentService.openErrorAlert(error.message);
          }
        } catch (e2) {
          this.globalComponentService.openErrorAlert(error.message);
        }
      });
    }
  }

  logout() {
    const subc = this.memberService.logout().subscribe(v => {
      this.globalComponentService.openSanckBar('會員已登出', 'X', {duration: 5000, horizontalPosition: 'right'});
    });
    this._subcs.push(subc);
  }

  openPrefere() {
    this.mpModal.open();
  }

  /** 放大網頁字體 */
  public growUPFontSize() {
    this.fontSizeService.increaseFontSize();
  }

  /** 重設網頁字體 */
  public resetUPFontSize() {
    this.fontSizeService.resetFontSize();
  }

  /** 縮小網頁字體 */
  public shrinkUPFontSize() {
    this.fontSizeService.decreaseFontSize();
  }
}
